import { collect } from 'collect.js'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useOrderStore } from '@/stores'

export function useFieldVisibility(prepare) {
  const route = useRoute()
  const orderStore = useOrderStore()
  const { orderData } = storeToRefs(orderStore)

  const preparedFields = {
    serviceData: [
      'pickup',
      'dropoff',
      'date_start',
      'hours',
      'reqs',
      'distance',
      'duration',
      'car'
    ],
    contactData: ['first_name', 'last_name', 'email', 'phone'],
    contact: ['pickup', 'dropoff', 'date_start', 'hours', 'reqs', 'car'],
    vehicle: ['pickup', 'dropoff', 'date_start', 'hours', 'reqs', 'distance', 'duration'],
    payment: ['pickup', 'dropoff', 'date_start', 'hours', 'reqs', 'distance', 'duration', 'car']
  }

  const sourceFields = computed(() => {
    return prepare?.value ?? route.name
  })

  const checkField = (field) => {
    // Проверяем, что поле присутствует в списке и имеет значение
    return (
      collect(preparedFields[sourceFields.value]).some(field) &&
      orderData.value[field] != null &&
      (field !== 'reqs' || orderData.value[field] !== '')
    )
  }

  return {
    checkField,
    preparedFields,
    sourceFields
  }
}
